// Keep <title> and <link rel="icon"> in sync with the currently-active brand.
// Fallbacks come from the super-admin Branding tab (set by GlobalConfigProvider
// via document.documentElement.dataset.defaultTitle / defaultFavicon). The
// `data-brand-active` flag tells GlobalConfigProvider to leave the tab alone
// while a brand is driving it.
import { useEffect } from "react";
import { API } from "@/lib/api";

function setFavicon(href) {
  const existing = document.querySelectorAll("link[rel~='icon']");
  existing.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  document.head.appendChild(link);
}

function readDefaults() {
  const ds = document.documentElement.dataset;
  return {
    title: ds.defaultTitle || "The Brand Hub",
    favicon: ds.defaultFavicon || "/favicon.svg",
  };
}

export function useBrandMeta(brand) {
  const name = brand?.name;
  const logoId = brand?.logo_file_id;
  useEffect(() => {
    const { title: defaultTitle, favicon: defaultFavicon } = readDefaults();
    if (name) {
      document.documentElement.dataset.brandActive = "1";
      document.title = `${name} / ${defaultTitle}`;
      setFavicon(logoId ? `${API}/files/${logoId}` : defaultFavicon);
    } else {
      delete document.documentElement.dataset.brandActive;
      document.title = defaultTitle;
      setFavicon(defaultFavicon);
    }
    return () => {
      const d = readDefaults();
      delete document.documentElement.dataset.brandActive;
      document.title = d.title;
      setFavicon(d.favicon);
    };
  }, [name, logoId]);
}
